import { render, staticRenderFns } from "./HtmlText.vue?vue&type=template&id=38b6ea33&scoped=true&"
import script from "./HtmlText.vue?vue&type=script&lang=js&"
export * from "./HtmlText.vue?vue&type=script&lang=js&"
import style0 from "./HtmlText.vue?vue&type=style&index=0&id=38b6ea33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b6ea33",
  null
  
)

export default component.exports